import { calculateFqnDepth, parseFqnToPathParts, removeCategoryPrefix } from '@/shared/lib/format/fqn';
import { buildAssetDetailUrl } from '@/shared/lib/url';

const MAX_GLOSSARY_LIST_TREE_DEPTH = 2;

export function resolveGlossaryTermListRowHref(
  glossaryContextCategory: string | undefined,
  recordFullyQualifiedName: string
): string {
  if (!glossaryContextCategory) {
    return buildAssetDetailUrl('glossaryTerm', recordFullyQualifiedName);
  }

  const recordCategory = parseFqnToPathParts(recordFullyQualifiedName)[0];
  const depth = calculateFqnDepth(recordFullyQualifiedName);

  if (glossaryContextCategory === recordCategory && depth <= MAX_GLOSSARY_LIST_TREE_DEPTH) {
    const termPath = removeCategoryPrefix(recordFullyQualifiedName);
    return `/glossary/${glossaryContextCategory}/${termPath}`;
  }

  return buildAssetDetailUrl('glossaryTerm', recordFullyQualifiedName);
}
